﻿export abstract class PWMath {

	public static roundNumber(num: number, places: number) {
		let d = Math.pow(10, places);

		return Math.round((num + Number.EPSILON) * d) / d;
	}

	public static sumValues = (obj:number) => Object.values(obj).reduce((a, b) => a + b, 0);
}

interface INumber {
	EPSILON: any
}

declare var Number: INumber;
